<app-banner-card
  [header]="'pages.creators.banner.title' | translate"
  [addButtonConfiguration]="addButtonConfiguration()"
  [breadcrumbs]="breadcrumbs"
>
  <div class="mt-16">
    <app-creators-kpi-cards />
  </div>
</app-banner-card>
